import { render } from "./UploaderComponent.vue?vue&type=template&id=648a00d5&scoped=true"
import script from "./UploaderComponent.vue?vue&type=script&lang=js"
export * from "./UploaderComponent.vue?vue&type=script&lang=js"

import "./UploaderComponent.vue?vue&type=style&index=0&id=648a00d5&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648a00d5"]])

export default __exports__